import { STATE_IDENTIFIER } from "./constants";

const {
  LOADER_IDENTIFIER,
  LIST_IDENTIFIER,
  CERTIFICATION_CONFIGURATIONS,
  SELECTED_CERTIFICATION,
  ENRICHMENT_SELECTED_CERTIFICATION,
} = STATE_IDENTIFIER;

export default {
  [CERTIFICATION_CONFIGURATIONS]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
  },
  [SELECTED_CERTIFICATION]: [],
  [ENRICHMENT_SELECTED_CERTIFICATION]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
  },
};
